import { SignerType } from "../../admin/models/contact.model";

export interface IReportContextValue {
    displayName: string;
    contextValue: string;
    replaceValue?: string;
    onBaseKeywordName: string;
    systemProvided?: boolean;
}

export enum ChiefOrderPostIssueOptions {
    Appeal,
    Modify,
    Vacate,
    Suspend,
    Revoke,
    Terminate
}

export interface ReportTemplateChiefOrderPostIssueOptions {
    typeOfPostIssueOption: ChiefOrderPostIssueOptions,
    associatedReportTemplateId: string
}

export interface ReportTemplate {
    allowedSignerTypes: SignerType[];
    categoryCode?: string;
    id: string;
    chiefsOrderPostIssueOptions?: ReportTemplateChiefOrderPostIssueOptions[];
    name?: string;
    reportContextValues: IReportContextValue[];
    typeCode: string;
    onBaseDocumentGroupName?: string;
    onBaseDocumentTypeName?: string;
}

export class LetterMergeConstants {
    static OrgId: IReportContextValue = { contextValue: "orgId", displayName: "Organization RICS Id", onBaseKeywordName: "DOGRM - RICS Owner ID Number", replaceValue: null, systemProvided: true };
    static OrgName: IReportContextValue = { contextValue: "orgName", displayName: "Organization Name", onBaseKeywordName: "DOGRM - Owner Name", replaceValue: null, systemProvided: true };
    static OrgAddress: IReportContextValue = { contextValue: "orgStreet", displayName: "Organization Address", onBaseKeywordName: "DOGRM - Address", replaceValue: null, systemProvided: true };
    static OrgCity: IReportContextValue = { contextValue: "orgCity", displayName: "Organization City", onBaseKeywordName: "DOGRM - City", replaceValue: null, systemProvided: true };
    static OrgState: IReportContextValue = { contextValue: "orgState", displayName: "Organization State", onBaseKeywordName: "DOGRM - State", replaceValue: null, systemProvided: true };
    static OrgZip: IReportContextValue = { contextValue: "orgZip", displayName: "Organization Zip", onBaseKeywordName: "DOGRM - Zip Code", replaceValue: null, systemProvided: true };
    static CertifiedMailDate: IReportContextValue = { contextValue: "certifiedMailDate", displayName: "Certified Mail Date", onBaseKeywordName: "DOGRM - Date Mailed", replaceValue: null, systemProvided: true };
    static CertifiedMailTrackingNumber: IReportContextValue = { contextValue: "mailNumber", displayName: "Certified Mail ID Number", onBaseKeywordName: "DOGRM - Certified Mail ID Number", replaceValue: null, systemProvided: true };

    static AllConstants: IReportContextValue[] = [LetterMergeConstants.OrgId, LetterMergeConstants.OrgName, LetterMergeConstants.OrgAddress, LetterMergeConstants.OrgCity,
        LetterMergeConstants.OrgState, LetterMergeConstants.OrgZip, LetterMergeConstants.CertifiedMailDate, LetterMergeConstants.CertifiedMailTrackingNumber
    ]
}

export class ChiefsOrderMergeConstants extends LetterMergeConstants {
   static ChiefsAuthority: IReportContextValue = { contextValue: "chiefAuthority", displayName: "Chief's Authority", onBaseKeywordName: null, replaceValue: null, systemProvided: true };
    static ChiefsDateSigned: IReportContextValue = { contextValue: "chiefDateSigned", displayName: "Chief's Date Signed", onBaseKeywordName: "DOGRM - Date Signed", replaceValue: null, systemProvided: true };
    static ChiefsDateIssued: IReportContextValue = { contextValue: "chiefDateIssued", displayName: "Chief's Date Issued", onBaseKeywordName: "DOGRM - Date Issued", replaceValue: null, systemProvided: true };
    static ChiefsOrderNumber: IReportContextValue = { contextValue: "chiefsOrderNumber", displayName: "Chief's Order Number", onBaseKeywordName: "DOGRM - RICS Chiefs Order ID Number", replaceValue: null, systemProvided: true };
    static ChiefsSignature: IReportContextValue = { contextValue: "chiefsSignature", displayName: "Chief's Order Signature", onBaseKeywordName: null, replaceValue: null, systemProvided: true };
    static ChiefSignerType: IReportContextValue = { contextValue: "chiefSignerType", displayName: "Chief's Signer Type", onBaseKeywordName: null, replaceValue: null, systemProvided: true };
    static ChiefLegalName: IReportContextValue = { contextValue: "chiefLegalName", displayName: "Chief's Legal Name", onBaseKeywordName: null, replaceValue: null, systemProvided: true };
    static PriorChiefsOrderNumber: IReportContextValue = { contextValue: "priorChiefsOrderNumber", displayName: "Prior issued Chief's Order", onBaseKeywordName: "DOGRM - RICS Chiefs Order ID Number", replaceValue: null, systemProvided: true };
    static SixMonthsAfterSignatureDate: IReportContextValue = { contextValue: "sixMonthsAfterSignatureDate", displayName: "Six Months After Signature Date", onBaseKeywordName: null, replaceValue: null, systemProvided: true };

    static AllConstants: IReportContextValue[] = [ChiefsOrderMergeConstants.OrgId, ChiefsOrderMergeConstants.OrgName, ChiefsOrderMergeConstants.OrgAddress, ChiefsOrderMergeConstants.OrgCity,
        ChiefsOrderMergeConstants.OrgState, ChiefsOrderMergeConstants.OrgZip, ChiefsOrderMergeConstants.ChiefsAuthority, ChiefsOrderMergeConstants.ChiefsDateSigned, ChiefsOrderMergeConstants.ChiefsDateIssued,
        ChiefsOrderMergeConstants.ChiefsOrderNumber, ChiefsOrderMergeConstants.ChiefsSignature, ChiefsOrderMergeConstants.ChiefSignerType, ChiefsOrderMergeConstants.ChiefLegalName,
        ChiefsOrderMergeConstants.CertifiedMailDate, ChiefsOrderMergeConstants.CertifiedMailTrackingNumber, ChiefsOrderMergeConstants.PriorChiefsOrderNumber, ChiefsOrderMergeConstants.SixMonthsAfterSignatureDate
    ]
}

 